import familiadosApiClient from '$utils/familiadosApiClient'
import { apiErrorService } from '$utils/services/apiErrorService'
import { cookiesStorage } from '$utils/services/cookiesStorage'
import { changeRecoveredPasswordFormToModel, mapUserIdData } from './user.mapper'
import { UserIdDataDto } from '$domain/model/user/user.model'

export const recoverPasswordPath = '/recover-password'
export const changePasswordPath = '/password-change'
export const deleteAccountPath = '/delete-account'
export const deleteUserAccountPath = '/user/delete-account'
export const confirmDeleteAccountPath = '/confirm-delete-account'
export const sendUserCallPath = '/user-call'
export const validateRecoverPasswordTokenPath = '/recover-password/validate-token'
export const confirmRecoverPasswordPath = '/recover-password/confirm'
export const getUserIdDataPath = '/user-id-data'

export const recoverPassword = async (email: string) => {
  try {
    await familiadosApiClient.post(recoverPasswordPath, email)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const changePassword = async passwords => {
  try {
    await familiadosApiClient.post(changePasswordPath, {
      ...passwords,
    })
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const deleteAccount = async () => {
  try {
    await familiadosApiClient.post(deleteAccountPath)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const confirmDeleteAccount = async token => {
  try {
    await familiadosApiClient.delete(confirmDeleteAccountPath, { token })
    cookiesStorage.deleteAllCookies()
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const sendUserCall = async phoneNumber => {
  try {
    await familiadosApiClient.post(sendUserCallPath, { phoneNumber })
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const validateRecoverPasswordToken = async (token: string) => {
  try {
    await familiadosApiClient.post(validateRecoverPasswordTokenPath, { token })
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const changeRecoveredPassword = async (passwords, token: string) => {
  try {
    const modelValues = changeRecoveredPasswordFormToModel(passwords, token)
    await familiadosApiClient.post(confirmRecoverPasswordPath, modelValues)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getUserIdData = async () => {
  try {
    const userIdData = await familiadosApiClient.get<UserIdDataDto>(getUserIdDataPath)
    return mapUserIdData(userIdData)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const deleteUserAccount = async () => {
  try {
    await familiadosApiClient.post(deleteUserAccountPath)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/user/user.manager.ts